import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Badge from 'flarum/common/components/Badge';
import UserCard from 'flarum/forum/components/UserCard';
import PostUser from 'flarum/forum/components/PostUser';
import CommentPost from 'flarum/forum/components/CommentPost';

app.initializers.add('bo3studio/flarum-rp-system', () => {
    // Add RP badge to user badges
    extend(app, 'getRequiredPermissions', function () {});

    // Show RP level badge next to username in posts
    extend(CommentPost.prototype, 'headerItems', function (items) {
        const post = this.attrs.post;
        const user = post.user();
        if (!user) return;

        const totalRp = user.attribute('totalRp') || 0;
        const scores = user.attribute('rpTagScores') || [];

        // Find score for the current discussion's tag
        const discussion = post.discussion();
        let currentTagScore = null;
        if (discussion && discussion.tags()) {
            const primaryTag = discussion.tags()[0];
            if (primaryTag) {
                currentTagScore = scores.find(s => s.tag_id == primaryTag.id());
            }
        }

        const levelName = currentTagScore ? currentTagScore.level_name : getGlobalLevelName(totalRp);
        const levelColor = currentTagScore ? currentTagScore.level_color : '#888888';

        items.add('rp-badge',
            m('span.RpBadge', {
                style: {
                    backgroundColor: levelColor,
                    color: '#fff',
                    padding: '1px 6px',
                    borderRadius: '3px',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    marginLeft: '6px',
                    display: 'inline-block',
                    lineHeight: '16px',
                },
                title: 'RP: ' + totalRp,
            }, levelName),
            10
        );
    });

    // Add RP info to user card
    extend(UserCard.prototype, 'infoItems', function (items) {
        const user = this.attrs.user;
        if (!user) return;

        const totalRp = user.attribute('totalRp') || 0;
        const scores = user.attribute('rpTagScores') || [];

        // Total RP display
        items.add('rp-total',
            m('.UserCard-rpTotal', [
                m('span.RpLabel', 'RP值: '),
                m('span.RpValue', { style: { color: '#e94560', fontWeight: 'bold' } }, totalRp),
            ]),
            -10
        );

        // Tag scores with progress bars
        if (scores.length > 0) {
            items.add('rp-scores',
                m('.UserCard-rpScores', [
                    m('h4.RpScoresTitle', '版块等级'),
                    ...scores.slice(0, 5).map(score =>
                        m('.RpScoreRow', [
                            m('.RpScoreHeader', [
                                m('span.RpTagName', {
                                    style: { color: score.tag_color || '#ccc' }
                                }, score.tag_name),
                                m('span.RpLevelName', {
                                    style: { color: score.level_color }
                                }, ' Lv.' + score.level + ' ' + score.level_name),
                            ]),
                            m('.RpProgressBar', [
                                m('.RpProgressFill', {
                                    style: {
                                        width: getProgressWidth(score) + '%',
                                        backgroundColor: score.tag_color || '#e94560',
                                    }
                                }),
                            ]),
                            m('.RpScoreFooter', [
                                m('span', score.score + ' RP'),
                                score.next_level_score
                                    ? m('span', '下一级: ' + score.next_level_score + ' RP')
                                    : m('span', '已满级'),
                            ]),
                        ])
                    ),
                ]),
                -20
            );
        }
    });
});

function getGlobalLevelName(totalRp) {
    if (totalRp >= 1500) return '传奇英雄';
    if (totalRp >= 500) return 'RP高手';
    if (totalRp >= 200) return '资深探索者';
    if (totalRp >= 50) return '旅行者';
    return '见习冒险者';
}

function getProgressWidth(score) {
    if (!score.next_level_score) return 100;
    const currentMin = score.score - (score.level > 1 ? score.score * 0.5 : 0);
    const range = score.next_level_score - currentMin;
    if (range <= 0) return 100;
    return Math.min(100, Math.max(5, ((score.score - currentMin) / range) * 100));
}
